import client from "@https/api";
import { IGiftFinderQuestionsResponse } from "@types";
import gate from "gate/gate";

const GiftFinderApi = {
    getQuestions: () =>
        gate.get<IGiftFinderQuestionsResponse, never, never>({
            client,
            url: "giftFinder/questions",
        }),
};

export default GiftFinderApi;
